module.exports = __webpack_public_path__ + "8ddcafb98403e3c126c5b64545911b0c.eot";


//////////////////
// WEBPACK FOOTER
// ./application/font/SourceSansPro-Regular.eot
// module id = 33
// module chunks = 0